import { SELECT_DETAIL_VIEW_OWNER } from '../actions/ActionTypes';
export default function selectedDetailOwnerId(state = {
  selectedDetailOwnerId: null
}, action) {
  switch (action.type) {
    case SELECT_DETAIL_VIEW_OWNER:
      return Object.assign({}, state, {
        selectedDetailOwnerId: action.payload
      });
    default:
      return state;
  }
}